import React from 'react'
import { FabButtonStyles } from './Style'
import { IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as GoIcon } from 'assets/icons/FatGo.svg';
import { Done } from '@mui/icons-material';

const NextButton = ({ disabled, size, action, finish }) => {

    return (
        <FabButtonStyles size={size} fill="white">
            <IconButton disabled={disabled} onClick={action}>
                {finish ?
                    <Done color="white" fontSize='large' />
                    :
                    <SvgIcon fontSize="small" component={GoIcon} inheritViewBox />}
            </IconButton>
        </FabButtonStyles>
    )
}

export default NextButton